/* ------------------------------------------------------------------------------
@name: User
--------------------------------------------------------------------------------- */

import { API_URL, BASE_URL } from "variables";
import { DataTable, Form, HttpRequest, SweetAlert } from "utilities";

const ElementSelector = [
  { id: "user_id" },
  { id: "name", validation: { required: true } },
  { id: "email", validation: { required: true, email: true, invalid: true } },
  { id: "role", type: "select", validation: { required: true } },
  {
    id: "password",
  },
  { id: "photo", type: "file" },
];

const ElementEvents = ["input", "blur"];

const User = (() => {
  // -----------------------
  // Fetch Roles for Select Option
  // -----------------------
  const fetchRoles = async (selectedRole = "") => {
    try {
      const res = await HttpRequest.custom({
        url: API_URL.roleGet,
        method: "POST",
      });

      if (res?.code === 200 && Array.isArray(res.data)) {
        const $roleSelect = $("#role");
        $roleSelect.empty();
        $roleSelect.append('<option value="">Select Role</option>');

        res.data.forEach((role) => {
          // Only show active roles
          if (role.status === "1") {
            const isSelected =
              role.name === selectedRole ? 'selected="selected"' : "";
            $roleSelect.append(
              `<option value="${role.id}" ${isSelected}>${role.name}</option>`
            );
          }
        });

        // Trigger change event for validation
        $roleSelect.trigger("change");
      } else {
        console.error("Failed to fetch roles:", res);
        $("#role").html('<option value="">No roles available</option>');
      }
    } catch (err) {
      console.error("Error fetching roles:", err);
      $("#role").html('<option value="">Error loading roles</option>');
    }
  };

  const handleRunDataTable = () => {
    const dataSetting = {
      selector: "js-data-user",
      url: API_URL.userGet,
      method: "POST",
    };

    const filterSetting = [{ id: "search", event: "keyup" }];

    const columnSetting = [
      {
        targets: 0,
        className: "dt-control",
        orderable: false,
        data: null,
        defaultContent: "",
        responsivePriority: 1,
        visible: false,
      },
      {
        targets: 1,
        render: (data) =>
          `<span class="user-avatar avatar-rounded mr-2"><img class="user-avatar__img" src="${data.photo}" /></span> ${data.name}`,
      },
      {
        targets: 4,
        className: "text-center",
        responsivePriority: 2,
        render: (data) => {
          const icon_status = data.status === "1" ? "ph-eye" : "ph-eye-slash";
          return `<div class="action-order"><button type="button" data-toggle="tooltip" data-placement="left" title="Status" class="btn btn-sm btn-default btn-trans waves-effect js-update-status" data-id="${data.id}" data-status="${data.status}"><i class="ph ${icon_status}"></i></button>
            <button type="button" data-toggle="tooltip" data-placement="left" title="Edit Password" class="btn btn-sm btn-default btn-trans waves-effect js-edit-password" data-id="${data.id}"><i class="ph ph-lock-key-open"></i></button>
            <button type="button" data-toggle="tooltip" data-placement="left" title="Edit" class="btn btn-sm btn-default btn-trans waves-effect js-edit-data" data-id="${data.id}"><i class="ph ph-pencil-simple"></i></button>
            <button type="button" data-toggle="tooltip" data-placement="left" title="Delete" class="btn btn-sm btn-danger btn-trans waves-effect js-delete-data" data-id="${data.id}"><i class="ph ph-trash"></i></button></div>`;
        },
      },
    ];

    DataTable.custom(dataSetting, filterSetting, columnSetting);
  };

  const handleRunValidation = () => {
    Form.validation(ElementEvents, ElementSelector);
  };

  const enterPasswordOnlyMode = () => {
    const $form = $(".js-form-user");
    if (!$form.length) return;
    $form.data("mode", "password");

    $form.find(".form-group").each(function () {
      const $g = $(this);
      if (
        $g.find("#password").length ||
        $g.find("#confirm_password").length ||
        $g.find("#user_id").length
      ) {
        $g.show();
      } else {
        $g.hide();
      }
    });

    $("#password").show();
    $("#confirm_password").show();
    $("#confirm_password").addClass("js-confirm-password");
  };

  const exitPasswordOnlyMode = () => {
    const $form = $(".js-form-user");
    if (!$form.length) return;
    $form.removeData("mode");
    $form.find(".form-group").show();
    updatePasswordVisibility();
    $("#confirm_password").removeClass("js-confirm-password");
  };

  const updatePasswordVisibility = () => {
    const userId = $("#user_id").val();
    const isNew = !userId || String(userId).trim() === "";
    if (isNew) {
      $("#password").show();
      $("#password").parents(".form-group").find(".col-form-label").show();
      $("#confirm_password").show();
      $("#confirm_password")
        .parents(".form-group")
        .find(".col-form-label")
        .show();
      $("#confirm_password").addClass("js-confirm-password");
    } else {
      $("#password").hide();
      $("#password").parents(".form-group").find(".col-form-label").hide();
      $("#confirm_password").hide();
      $("#confirm_password")
        .parents(".form-group")
        .find(".col-form-label")
        .hide();
      $("#confirm_password").removeClass("js-confirm-password");
      // if ($(".button-edit-profile").length) {
      //   $("#role").parents(".form-group").find(".col-form-label").hide();
      //   $("#role").hide();
      // } else {
      //   $("#role").parents(".form-group").find(".col-form-label").show();
      //   $("#role").show();
      // }
    }
  };

  const handleClickValidation = () => {
    $('.js-form-user button[type="submit"]').on("click", (e) => {
      e.preventDefault();

      const $form = $(".js-form-user");
      const mode = $form.data("mode");

      if (mode === "password") {
        $("#password").blur();
        $("#confirm_password").blur();
      } else {
        $.each(ElementSelector, (i, v) => {
          $("#" + v.id).blur();
        });
      }

      setTimeout(() => {
        let hasError = false;
        if (mode === "password") {
          if (
            $(".js-form-user #password").closest(".form-group").find(".error")
              .length
          )
            hasError = true;
          if (
            $(".js-form-user #confirm_password")
              .closest(".form-group")
              .find(".error").length
          )
            hasError = true;
          if ($(".js-form-user #password[aria-invalid='true']").length)
            hasError = true;
          if ($(".js-form-user #confirm_password[aria-invalid='true']").length)
            hasError = true;
          if ($(".js-form-user #password.is-invalid").length) hasError = true;
          if ($(".js-form-user #confirm_password.is-invalid").length)
            hasError = true;
        } else {
          if ($(".js-form-user .error").length) hasError = true;
          if ($(".js-form-user [aria-invalid='true']").length) hasError = true;
          if ($(".js-form-user .is-invalid").length) hasError = true;
        }

        if (!hasError) {
          handlePostData();
        }
      }, 50);
    });
  };

  const handleEmptyInput = () => {
    $('button[data-dismiss="modal"]').on("click", () => {
      Form.emptyData(ElementSelector);
      exitPasswordOnlyMode();
    });
  };

  // -----------------------
  // Get form data (edit full) - DIPERBAIKI
  // -----------------------
  const handleGetFormData = () => {
    $("body").on("click", ".js-edit-data", async (e) => {
      e.preventDefault();
      const _this = $(e.currentTarget);

      try {
        const id = _this.attr("data-id");
        console.log("Editing user ID:", id);

        // Buat FormData dengan benar
        const formData = new FormData();
        formData.append("user_id", id);

        // Debug: lihat isi FormData
        console.log("FormData entries:");
        for (let [key, value] of formData.entries()) {
          console.log(key, value);
        }

        // Get user data first
        const res = await HttpRequest.custom({
          url: API_URL.userGet,
          method: "POST",
          data: formData,
          isFormData: true, // Pastikan ini true
        });

        console.log("Response from API:", res);

        if (res?.code === 200 && res.data) {
          const userData = res.data;
          console.log("User data loaded:", userData);

          // Set basic form fields
          $("#user_id").val(userData.user_id || "");
          $("#name").val(userData.name || "");
          $("#email").val(userData.email || "");

          // Fetch roles and set selected role
          await fetchRoles(userData.role || "");
          console.log("Selected role set to:", userData.role);

          // Update password visibility
          updatePasswordVisibility();

          // Handle photo if exists
          const $dropify = $(".js-dropify");
          if ($dropify.length && userData.photo) {
            try {
              // Reset dropify
              const dropifyInstance = $dropify.data("dropify");
              if (dropifyInstance) {
                dropifyInstance.resetPreview();
                dropifyInstance.clearElement();

                // Jika ada foto, set preview
                if (userData.photo && !userData.photo.includes("default.jpg")) {
                  // Simpan URL untuk preview
                  $dropify.attr("data-default-file", userData.photo);
                  // Re-init dropify untuk menampilkan preview
                  $dropify.dropify();
                }
              }
            } catch (dropifyErr) {
              console.warn("Dropify error:", dropifyErr);
            }
          }

          // Show modal
          $("#modalUser").modal("show");
          $("#myLargeModalLabel").text("Edit Admin");

          // Exit password only mode
          exitPasswordOnlyMode();

          // Trigger validation update
          setTimeout(() => {
            $("#role").trigger("change");
          }, 100);
        } else {
          console.error("API returned error:", res);
          SweetAlert.config(
            res?.message || "Failed to load user data",
            "error"
          );
        }
      } catch (err) {
        console.error("Error in handleGetFormData:", err);
        SweetAlert.config(
          "Error loading user data. Please check console.",
          "error"
        );
      }
    });
  };

  // Fungsi HttpRequest.custom harus mendukung FormData
  // Jika utilitas HttpRequest tidak mendukung isFormData, kita perlu perbaiki atau buat custom request

  const handleEditPassword = () => {
    $("body").on(
      "click",
      ".js-edit-password, .js-update-password",
      async (e) => {
        const _this = $(e.currentTarget);

        const formData = new FormData();
        const id = _this.attr("data-id");
        formData.append("user_id", id);

        const data = {
          url: API_URL.userGet,
          method: "POST",
          data: formData,
          elementSelector: ElementSelector,
        };

        try {
          const maybePromise = Form.getFormData(data);
          if (maybePromise && typeof maybePromise.then === "function") {
            await maybePromise;
          } else {
            await new Promise((r) => setTimeout(r, 120));
          }
        } catch (err) {
          console.warn("Form.getFormData failed", err);
        } finally {
          const $modal = $(".modal").filter(function () {
            return $(this).is(":visible");
          });
          if ($modal.length === 0) $(".modal").first().modal("show");
          // Show modal
          $("#myLargeModalLabel").text("Edit Password");
          enterPasswordOnlyMode();
          setTimeout(() => $("#password").focus(), 120);
        }
      }
    );
  };

  const handlePostData = () => {
    const formData = Form.dataColletion(ElementSelector);

    let apiUrl = API_URL.userAdd;
    if ($("#user_id").val().length !== 0) apiUrl = API_URL.userEdit;

    const data = {
      url: apiUrl,
      method: "POST",
      data: formData,
      elementSelector: ElementSelector,
    };

    const response = HttpRequest.custom(data);

    if (response && response.code === 200) {
      $(".modal").modal("hide");
      SweetAlert.config(response.message, "success");
      Form.emptyData(ElementSelector);
      exitPasswordOnlyMode();

      if ($(".js-form-order").length > 0) {
        $(".js-input-customer").val(response.data.name);
        $(".js-input-phone").val(response.data.phone);
      } else {
        $("#dataTable").DataTable().ajax.reload();
      }
    } else {
      SweetAlert.config(
        response ? response.message : "Request failed",
        "error"
      );
    }
  };

  const handleDeleteData = () => {
    $("body").on("click", ".js-delete-data", (e) => {
      const _this = $(e.currentTarget);
      const id = _this.attr("data-id");
      const formData = new FormData();
      formData.append("user_id", id);

      const data = { url: API_URL.userDelete, method: "POST", data: formData };
      Form.deleteData(data);
    });
  };

  const handleUpdateStatus = () => {
    $("body").on("click", ".js-update-status", (e) => {
      const _this = $(e.currentTarget);
      const id = _this.attr("data-id");
      let status = _this.attr("data-status");
      status = status == 0 || status == null ? 1 : 0;

      const formData = new FormData();
      formData.append("user_id", id);
      formData.append("status", status);

      const data = { url: API_URL.userEdit, method: "POST", data: formData };
      Form.updateStatus(data);
    });
  };

  const handleShowModal = () => {
    // Load roles when modal is about to show (for add mode)
    $("#modalUser").on("show.bs.modal", async function () {
      const userId = $("#user_id").val();
      const isNew = !userId || String(userId).trim() === "";

      if (isNew) {
        // For new user, fetch roles without selection
        await fetchRoles();
        $("#myLargeModalLabel").text("Add Admin");
      }
    });

    $(".modal").on("shown.bs.modal", function () {
      const $form = $(".js-form-user");
      if (!$form.data("mode")) updatePasswordVisibility();
    });

    $(".modal").on("hidden.bs.modal", function () {
      exitPasswordOnlyMode();
      Form.emptyData(ElementSelector);
      // Reset dropify
      if ($(".js-dropify").length) {
        const dropify = $(".js-dropify").dropify();
        dropify = dropify.data("dropify");
        dropify.resetPreview();
        dropify.clearElement();
      }
    });
  };

  // -----------------------
  // Initialize dropify for file upload
  // -----------------------
  const initDropify = () => {
    if ($(".js-dropify").length) {
      $(".js-dropify").dropify({
        messages: {
          default: "Drag and drop a file here or click",
          replace: "Drag and drop or click to replace",
          remove: "Remove",
          error: "Ooops, something wrong appended.",
        },
        error: {
          fileSize: "The file size is too big (2M max).",
        },
      });
    }
  };

  const init = () => {
    if ($(".js-data-user").length) {
      handleRunDataTable();
      handleDeleteData();
      handleGetFormData();
      handleUpdateStatus();
    }
    if ($(".js-form-user").length) {
      handleRunValidation();
      handleClickValidation();
      handleEmptyInput();
      handleShowModal();
      handleEditPassword();
      initDropify();

      // Load roles on page load
      fetchRoles();
    }
  };

  return { init };
})();

export default User;
